import React, { useEffect, useState } from "react";
import "../../src/App.css";
import 'sweetalert2/dist/sweetalert2.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from "react-bootstrap";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DataTable from 'react-data-table-component';
import config from "./config";
import { makeApiRequest } from "../axiosService/apiCall";

function Adminclaimhistory() {
    const [claimedData, setClaimedData] = useState([]);
    const [copiedValue, setCopiedValue] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const getadminmlmclaimhistory = async () => {
        try {
            setLoading(true);
            let params = { url: `adminmlmclaimhistory`, method: 'GET' };
            let response = await makeApiRequest(params);
            // console.log('response', response)
            if (response.status === true && response.adminmlmclaimhistory) {
                setClaimedData(response.adminmlmclaimhistory);
            } else {
                setClaimedData([]);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getadminmlmclaimhistory();
    }, []);

    const compressString = (str) => {
        return str && str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str || 'N/A';
    };

    const handleCopy = (value) => {
        setCopiedValue(value);
        setTimeout(() => setCopiedValue(''), 2000);
    };

    // Filtering the data
    const filteredData = claimedData.filter(row => {
        const formattedDate = row.date
            ? new Date(row.date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
            : "-";

        return (
            row.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            formattedDate.includes(searchQuery)
        );
    });

    // Pagination: Get Current Page Data
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1, // Maintain serial number across pages
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => new Date(row.date).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }),
            sortable: true,
            width: "200px"
        },
        {
            name: 'Email',
            selector: row => row.email || 'N/A',
            sortable: true,
            width: "300px"
        },
        {
            name: 'From Address',
            selector: row => compressString(row.fromAddress),
            sortable: true,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.fromAddress)}
                    <CopyToClipboard text={row.fromAddress} onCopy={() => handleCopy(row.fromAddress)}>
                        <FontAwesomeIcon icon={faCopy} className="ms-2" />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'To Address',
            selector: row => compressString(row.toAddress),
            sortable: true,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.toAddress)}
                    <CopyToClipboard text={row.toAddress} onCopy={() => handleCopy(row.toAddress)}>
                        <FontAwesomeIcon icon={faCopy} className="ms-2" />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'Transaction Hash',
            selector: row => row.txhash ? (
                <a href={`${config[`${row.symbol}_URL`]}${row.txhash}`} target="_blank" rel="noopener noreferrer">
                    {compressString(row.txhash)}
                </a>
            ) : "-",
            sortable: true,
            width: "200px"
        },
        {
            name: 'Transaction Amount',
            selector: row => row.amount || 'N/A',
            sortable: true,
            width: "200px"
        }
    ];

    return (
        <div className='App'>
            <div className='container'>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">Admin Claim History</h3>
                            </div>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='row me-5'>
                                        <div className='col-lg-9'>
                                            <input 
                                                className="form-control form-search" 
                                                type="text" 
                                                placeholder="Search By Email or Date" 
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {loading ? (
                                        <div className="text-center mt-4">
                                            <Spinner animation="border" />
                                        </div>
                                    ) : (
                                        <div className='custom-datascroll'>
                                            <DataTable 
                                                columns={columns} 
                                                data={paginatedData} 
                                                pagination
                                                paginationServer
                                                paginationTotalRows={filteredData.length}
                                                paginationPerPage={rowsPerPage}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: "Rows per page:",
                                                    rangeSeparatorText: "of",
                                                    selectAllRowsItem: true,
                                                    selectAllRowsItemText: "All"
                                                }}
                                                onChangePage={setCurrentPage} // Handle page change
                                                onChangeRowsPerPage={(newPerPage, page) => {
                                                    setRowsPerPage(newPerPage);
                                                    setCurrentPage(page);
                                                }}
                                                highlightOnHover
                                                dense 
                                            />
                                        </div>
                                    )}
                                    <ToastContainer />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Adminclaimhistory;
